import { FC } from 'react'
import styled from 'styled-components'
import { checkCategoryDepthAndShowWarning } from '../../module/utils'
import useJobCategoryStore from '../../store/store.jobCategory'
import { TJobCategory } from '../../type/jobCategoryStoreType'
import DrawCategoryGroup, { TDrawCategoryGroupInfo } from './DrawCategoryGroup'

interface IFCategoryGroupAllProps {
  parentCategory: TJobCategory
  className?: string
}

const CategoryGroupAll: FC<IFCategoryGroupAllProps> = ({
  parentCategory,
  className,
}) => {
  const { id, isSelect, depth, selectedChildrenIds } = parentCategory

  checkCategoryDepthAndShowWarning(depth, [1])

  const activeId = useJobCategoryStore((state) => state.activeId)
  const selectId = useJobCategoryStore((state) => state.selectId)
  const unSelectId = useJobCategoryStore((state) => state.unSelectId)
  const unSelectIdWithChildren = useJobCategoryStore(
    (state) => state.unSelectIdWithChildren,
  )
  const isSelectAll = selectedChildrenIds.length === 0 && isSelect

  const categoryGroup: TDrawCategoryGroupInfo = {
    id,
    name: '전체',
    isSelect: isSelectAll,
    isActive: false,
  }

  const handleSelectCategory = (categoryGroupId: string) => {
    if (isSelectAll) {
      return unSelectId(categoryGroupId)
    }
    if (selectedChildrenIds.length !== 0) {
      unSelectIdWithChildren(categoryGroupId)
    }
    activeId(categoryGroupId)
    selectId(categoryGroupId)
  }

  return (
    <StyledWrapper
      categoryGroup={categoryGroup}
      onClick={handleSelectCategory}
      className={className}
    />
  )
}

export default CategoryGroupAll

const StyledWrapper = styled(DrawCategoryGroup)``
